export default "./dist/stdassets/images/icons/select.png";